import React, { Fragment } from 'react';
import EmbedCode from '../../common/embed-code';

interface Props {
  spotId: string;
  themeName: string;
}

const ManualEmbedCode: React.FC<Props> = ({ spotId, themeName }) => (
  <Fragment>
    <EmbedCode type="reactions" spotId={spotId} themeName={themeName} />
    <p className="embed-code-following-description">
      <span>
        Embed this code where you’d like the reactions to appear. (If you already used a manual code
        you must add <span className="head-tag">data-reactions-theme=&quot;{themeName}&quot;</span>
        for updates to take affect).
      </span>
    </p>
  </Fragment>
);

export default ManualEmbedCode;
